<div style="display: flex; justify-content: space-between; margin-bottom: 30px">
  <h2>Copiar Promoción</h2>
  <div style="display: flex">
    <button type="submit" mat-flat-button (click)="onSubmit()" style="margin-right: 20px" class="btn-success" [disabled]="form.invalid" appPermissionControl="P295B0001">
      <mat-icon>content_copy</mat-icon>
      Aceptar
    </button>
    <button mat-flat-button class="btn-back" (click)="close()" appPermissionControl="P295B0002">
      <mat-icon>close</mat-icon>
      Cerrar
    </button>
  </div>
</div>
<form [formGroup]="form" appPermissionControl="P295F0001">
  <div class="form-row">
    <!-- Origen -->
    <div class="form-field">
      <select formControlName="origen" class="form-control" appPermissionControl="P295K0001">
        <option [value]="null">Seleccionar Capital</option>
        <option *ngFor="let origen of origenes" [value]="origen.sPromocion">{{ origen.sPromocion }} | {{ origen.descripcion }}</option>
      </select>
      <label>Origen</label>
    </div>

    <!-- Descripción -->
    <!-- <div class="form-field flex-grow-1">
      <input formControlName="descripcion" class="form-control" />
      <label>Descripción</label>
    </div> -->

    <!-- Destino -->
    <div class="form-field">
      <input formControlName="destino" type="text" class="form-control" appPermissionControl="P295K0002">
      <label>Destino</label>
    </div>
  </div>
  <div class="form-row">
    <div class="card flex justify-content-center">
      <div class="cont-checks">
        <div class="flex align-items-center">
          <p-radioButton name="copia" value="1" formControlName="copia" inputId="todo" />
          <label for="todo" style="margin-left: 4px"> Todo </label>
        </div>

        <div class="flex align-items-center">
          <p-radioButton name="copia" value="2" formControlName="copia" inputId="definiciones" />
          <label for="definiciones" style="margin-left: 4px"> Definiciones </label>
        </div>

        <div class="flex align-items-center">
          <p-radioButton name="copia" value="3" formControlName="copia" inputId="contabilidad" />
          <label for="contabilidad" style="margin-left: 4px"> Contabilidad </label>
        </div>
      </div>
    </div>
  </div>
</form>
